import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement, Children } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon/Icon.js';
import { getAppearanceClasses } from '../../utils/taillwind.js';
import { Tooltip } from '../Tooltip/Tooltip.js';

var _excluded = ["appearance", "disabled", "href", "fluid", "target", "tooltip", "type", "overlay", "modal", "menu", "popover"];
var Button = /*#__PURE__*/forwardRef(function Button(props, ref) {
  var _cn, _props$className;

  var appearance = props.appearance,
      disabled = props.disabled,
      href = props.href,
      fluid = props.fluid,
      target = props.target,
      tooltip = props.tooltip,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      overlay = props.overlay,
      modal = props.modal,
      menu = props.menu,
      popover = props.popover,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var className = cn('yt-button', (_cn = {}, _cn[getAppearanceClasses(appearance)] = !!appearance, _cn['w-full'] = fluid, _cn), props.className);
  var isIconButton = (_props$className = props.className) === null || _props$className === void 0 ? void 0 : _props$className.includes('yt-button--icon');
  var extra;

  if (menu && !isIconButton) {
    extra = createElement("span", {
      className: "yt-button__menu__icon"
    }, createElement(Icon, {
      name: "chevron-down"
    }));
  }

  var Tag = href ? 'a' : 'button';
  var button = createElement(Tag, Object.assign({}, otherProps, {
    "aria-disabled": disabled ? 'true' : undefined,
    className: className,
    disabled: disabled,
    href: href,
    target: Tag === 'a' ? target : undefined,
    type: Tag !== 'a' ? type : undefined,
    ref: ref
  }), Children.count(props.children) > 1 ? Children.map(props.children, function (child) {
    return typeof child === 'string' ? createElement("span", null, child) : child;
  }) : props.children, extra);

  if (overlay || modal || menu || popover) {
    if (overlay) {
      return overlay({
        disclosure: button,
        disclosureTooltip: tooltip
      });
    } // legacy


    if (modal) {
      return modal({
        disclosure: button,
        disclosureTooltip: tooltip
      });
    }

    if (menu) {
      return menu({
        appearance: appearance,
        className: isIconButton ? 'yt-menu--icon' : undefined,
        disclosure: button,
        disclosureTooltip: tooltip
      });
    }

    if (popover) {
      return popover({
        disclosure: button,
        disclosureTooltip: tooltip
      });
    }
  }

  if (tooltip) {
    return createElement(Tooltip, {
      title: tooltip
    }, button);
  }

  return button;
});

export { Button };
//# sourceMappingURL=Button.js.map
